import BUIDLTokenAbi from "./abis/buidlToken";
import ERC20Abi from "./abis/erc20";
import factoryAbi from "./abis/factory";
import starterInfoAbi from "./abis/starterInfo";
import starterStakingAbi from "./abis/starterStaking";
import starterPresaleAbi from "./abis/starterPresale";
import vestingAbi from "./abis/vesting";
import vestTokenAbi from "./abis/vest";
import swapRouterAbi from "./abis/swapRouter";
import { ENVIRONMENT } from "../../constants/constants";

const config = {
  BUIDLTokenAddress: "0x0000000000000000000000000000000000000000",
  BUIDLTokenAbi,
  ERC20Abi,
  factoryAbi,
  factoryAddress: "0x0000000000000000000000000000000000000000",

  starterInfoAddress: "0x0000000000000000000000000000000000000000",
  starterInfoAbi,

  starterStaking: "0x0000000000000000000000000000000000000000",
  starterStakingAbi,

  vestingAddress: "0x0000000000000000000000000000000000000000",
  vestingAbi,
  vestToken: "0x0000000000000000000000000000000000000000",
  vestTokenAbi,
  starterVestingAddress: "0x0000000000000000000000000000000000000000",

  wethAddress: "0x0000000000000000000000000000000000000000",
  stakingToken: "0x0000000000000000000000000000000000000000",
  stakingTokenName: "BUIDL",
  stakingContracts: ["0x0000000000000000000000000000000000000000"],
  swapSymbol: "ETH",
  swapToken: "0x0000000000000000000000000000000000000000",
  swapTokenAbi: ERC20Abi,
  swapRouter: "0x0000000000000000000000000000000000000000",
  swapRouterAbi,

  starterPresaleAbi,
};

if (ENVIRONMENT === "mainnet") {
  config.BUIDLTokenAddress = "0xdADc4F8E9d8d37294de0E02A2Ce8Cc0c90A4F6c2";
  config.factoryAddress = "0xf1629ee40bdd6Af176221924F8Aeb899E23240a4";
  config.starterInfoAddress = "0xdfd485f29BA0e726e87065f313e0b2458eAE1506";
  config.starterStaking = "0xb3BC23ceD4fae30152870012d659267CEcaedD35";
  config.vestingAddress = "0xE8759dC246eF451d763a12d4e79244627507BD7F";
  config.vestToken = "0xdADc4F8E9d8d37294de0E02A2Ce8Cc0c90A4F6c2";
  config.starterVestingAddress = "0xE8759dC246eF451d763a12d4e79244627507BD7F";
  config.wethAddress = "0x4200000000000000000000000000000000000006";
  config.usdcAddress = "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
  config.stakingToken = "0xdADc4F8E9d8d37294de0E02A2Ce8Cc0c90A4F6c2";
  config.stakingContracts = ["0xb3BC23ceD4fae30152870012d659267CEcaedD35"];
  config.swapToken = "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
  config.swapSymbol = "USDC";
  config.swapRouter = "0x4752ba5DBc23f44D87826276BF6Fd6b1C372aD24"; // uniswap v2 router on Base
} else if (ENVIRONMENT === "testnet") {
  config.BUIDLTokenAddress = "0x1fc09bC5355C77Fa9925c614223360b1d8cDE673";
  config.factoryAddress = "0xb7a4B9E2C2877EeD2E306D8A200692f120daE931";
  config.starterInfoAddress = "0x4c575528E32b2D639Def5408839144dff7091009";
  config.starterStaking = "0xE3dB3b7c0e83799d63B56640adea950C34dc5643";
  config.vestingAddress = "0x3C24256B2cE30c88c29cc57e273958038B62222a";
  config.vestToken = "0x22f6c963e3da212e050da4852c472988dab52f31";
  config.starterVestingAddress = "0x0e7b582003de0E541548cF02a1F00725Df6E6E6f";
  config.wethAddress = "0x4200000000000000000000000000000000000006";
  config.usdcAddress = "0x0000000000000000000000000000000000000000";
  config.stakingToken = "0x1fc09bC5355C77Fa9925c614223360b1d8cDE673";
  config.stakingContracts = ["0xE3dB3b7c0e83799d63B56640adea950C34dc5643"];
  config.swapToken = "0x4200000000000000000000000000000000000006";
  config.swapRouter = "0x327Df1E6de05895d2ab08513aaDD9313Fe505d86";
}

export default config;
